import { createContext, useContext } from "react";
import { SourceItem } from "../shared/models/source-item.model";

type ArrayContextType = {
    setArray: (array: SourceItem[]) => void;
} | null;

export const ArrayStateContext = createContext<ArrayContextType | undefined>(undefined);

type ArrayProviderProps = {
    setArray: (array: Array<SourceItem>) => void;
    children: React.ReactNode;
};

export const ArrayProvider = ({ setArray, children }: ArrayProviderProps) => {
    return <ArrayStateContext.Provider value={{ setArray }}>{children}</ArrayStateContext.Provider>;
};

// Custom hook to use the context
export const useArrayContext = () => {
    const context = useContext(ArrayStateContext);
    if (!context) {
        throw new Error("useArrayContext must be used within a ArrayStateProvider");
    }
    return context;
};